



















import settings from '@/settings.coffee'
import gql from '@/gqlService.coffee'
import mutations from '@/gql/mutations.coffee'

export default {
    "name": "Message"
    "props": {
        "msg": false
    }
    "computed":{}
    "methods":
        "openBox": ()->
            this.opened = not this.opened
            this.markRead()
        "markRead": ()->
            if not this.msg.read
                mutations.run("message_mark_read", [this.msg.uid])
        "deleteMsg": ()->
            mutations.run("message_delete", [this.msg.uid])

    "data":()->
        {
            "opened": false
        }
}
